<template>
  <div class="row mt-5">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER'"
              :to="{ name: 'groupCoachingInvitationToFirstAppointmentList', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'groupCoachingInvitationToFirstAppointmentList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Einladungsschreiben
          </router-link>
          <router-link
              :to="{ name: 'groupCoachingFirstInterviewForm', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'groupCoachingFirstInterviewForm' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Erstgespräch
          </router-link>
          <router-link
              :to="{ name: 'groupCoachingProtocolList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'groupCoachingProtocolList' }"
              aria-controls="nav-profile"
              aria-selected="false">
            Sitzungsprotokolle
          </router-link>
          <router-link
              :to="{ name: 'groupCoachingFinalInterviewForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'groupCoachingFinalInterviewForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Abschlussgespräch
          </router-link>
          <router-link
              :to="{ name: 'groupCoachingDocumentsForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'groupCoachingDocumentsForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Dokumente
          </router-link>
          <router-link
              v-if="isDigitalSignature"
              :to="{ name: 'groupCoachingCoachingMeetingList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'groupCoachingCoachingMeetingList' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Anwesenheitsliste monatlich
          </router-link>

        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  currentUser: {
    type: Object,
    required: true,
  },
});

const coaching           = toRefs(props)[ 'coaching' ];
const currentUser        = toRefs(props)[ 'currentUser' ];
const currentUserRole    = currentUser?.value?.roles[ 0 ];
const isDigitalSignature = coaching.value.digitalSignature;
</script>

<style scoped>

</style>